import { VIDEO_BLOCK_RECEIVE, VIDEO_BLOCK_ERROR } from './VideoBlock.action';
import { error as errorReducer } from '../../../Reducers/Error.reducer';

const defaultState = {
    result: []
}
export const VideoBlockReducer = (state = defaultState, action) => {
    switch (action.type) {
        case VIDEO_BLOCK_RECEIVE:
            return {
                ...state,
                result: [...state.result, action.payload],
            }
        case VIDEO_BLOCK_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        default:
            return state;
    }
}